module.exports = __webpack_public_path__ + "img/faculty slam BOV action.1053bf40.png";